import { createId } from '@lmt/unicorn-shared/app/helpers/create-id';
import { ReactNode, useState } from 'react';
import * as React from 'react';

import styles from './CheckBox.module.scss';
import { AppTooltip } from './tooltip/AppTooltip';
import HintIcon from '@lmt/unicorn-shared/app/icons/i.svg?react';

interface Props {
  value?: string | number;
  name?: string;
  defaultChecked?: boolean;
  title?: string;
  checked?: boolean;
  className?: string;
  disabled?: boolean;
  isTooltipEnabled?: boolean;
  tooltipText?: string;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  testId?: string;
  children?: ReactNode;
  hint?: React.ReactNode;
  showHintIfDisabled?: boolean;
}

export const CheckBox = React.forwardRef<HTMLInputElement, Props>(
  function CheckBox(props, ref) {
    const [internalId] = useState(createId());
    const id =
      props.name != undefined
        ? `uni-check-box-${props.name + (props.value ? `-${props.value}` : '')}`
        : internalId;
    return (
      <div
        className={props.className}
        data-app-field={props.title}
        title={props.isTooltipEnabled ? props.tooltipText : undefined}
      >
        <input
          ref={ref}
          name={props.name}
          defaultChecked={props.defaultChecked}
          id={id}
          readOnly={!props.onClick}
          className={styles.customCheckbox}
          type="checkbox"
          checked={props.checked}
          disabled={props.disabled}
          onClick={props.onClick}
          onChange={props.onChange}
          value={props.value}
        />
        <label
          htmlFor={id}
          data-test-id={props.testId}
          data-show-if-disabled={props.showHintIfDisabled}
        >
          {props.title ?? props.children}
          {props.hint ? (
            <AppTooltip title={props.hint}>
              <div onClick={(e) => e.preventDefault()} className={styles.hint}>
                <HintIcon />
              </div>
            </AppTooltip>
          ) : null}
        </label>
      </div>
    );
  },
);
